module.exports = __webpack_public_path__ + "static/media/144-algeria.54cc0933.svg";